"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const CardBlock_vue_1 = __importDefault(require("./CardBlock.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AddressInfo',
    props: {
        address: {
            type: String,
            default: "",
        },
        contact: {
            type: String,
            default: "",
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createVNode)(CardBlock_vue_1.default, {
                    title: "Cím",
                    value: `${__props.address}`
                }, null, 8, ["value"]),
                (0, vue_2.createVNode)(CardBlock_vue_1.default, {
                    title: "Elérhetőségek",
                    value: `${__props.contact}`
                }, null, 8, ["value"])
            ]));
        };
    }
});
